import { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useHistory } from 'react-router-dom';

import TalkingParrot from '../../../assets/images/talking-parrot.png';
import GoLingo from '../../../assets/images/logo-text.png';

import Login from './Login/Login';
import SignUp from './SignUp';

const Welcome = ({ originalReferer }) => {
  const { t: translate } = useTranslation();
  const { pathname, search } = useLocation();
  let urlPath = pathname.replace('/', ''); //remove slash
  urlPath = urlPath === 'dashboard-login' ? 'login' : urlPath;
  const urlSearch = useMemo(() => new URLSearchParams(search), [search]).get(
    'lang',
  );
  const history = useHistory();
  const [activeTab, setActiveTab] = useState(urlPath ? urlPath : 'landing');

  useEffect(() => {
    if (activeTab !== 'landing') {
      if (urlPath !== activeTab) {
        history.push(`/${activeTab}`);
      }
    }
  }, [activeTab]);

  return (
    <div className="landing-page">
      <img
        src={TalkingParrot}
        alt="golingo Parrot"
        title="golingo Parrot"
        className="parrot"
      />
      <div className="intro-box">
        <p className="intro-text">{translate('welcome-to')}</p>
        <img src={GoLingo} alt="golingo" title="golingo" className="logo" />
      </div>

      <div className="input-container">
        <div
          className={`input-boxes input-boxes--landing ${
            activeTab === 'landing' ? 'input-boxes--active' : ''
          }`}>
          <div className="intro-box__options">
            <span className="divide">{translate('no-account')}</span>
            <button
              className="button button--success"
              onClick={() => {
                setActiveTab('register');
              }}>
              {translate('sign-up')}
            </button>
          </div>
          <div className="intro-box__options">
            <span className="divide">{translate('has-account')}</span>
            <button
              className="button button--ghost"
              onClick={() => {
                setActiveTab('login');
              }}>
              {translate('login')}
            </button>
          </div>
        </div>
        <div
          className={`input-boxes input-boxes--login ${
            activeTab === 'login' ? 'input-boxes--active' : ''
          }`}>
          {activeTab === 'login' && (
            <Login
              originalReferer={originalReferer}
              setActiveTab={setActiveTab}
            />
          )}
          <div className="intro-box__options">
            <span className="divide">{translate('no-account')}</span>
            <button
              className="button button--ghost"
              onClick={() => {
                setActiveTab('register');
              }}>
              {translate('sign-up')}
            </button>
          </div>
        </div>
        <div
          className={`input-boxes ${
            activeTab === 'register' ? 'input-boxes--active' : ''
          }`}>
          {activeTab === 'register' && (
            <SignUp
              originalReferer={originalReferer}
              registerLang={urlSearch}
            />
          )}
          <div className="intro-box__options">
            <span className="divide">{translate('has-account')}</span>
            <button
              className="button button--ghost"
              onClick={() => {
                setActiveTab('login');
              }}>
              {translate('login')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
